export default {
  website: {
    website_1001:
      'Vhall-tansmisión en vivo, transmisión por internet en vivo, transmisión de vídeo en vivo, plataforma de educación en línea, plataforma de transmisión de video en vivo, sistema de transmisión de vídeo por internet, plataforma interactiva de transmisión en vivo más grande de China',
    website_1002:
      'Vhall, Vhall en vivo, transmisión en vivo en línea, videoconferencia, capacitación remota, software de transmisión en vivo,transmisión en vivo, transmisión en vivo,transmisión por internet en vivo, transmisión de vídeo en vivo, plataforma de enseñanza en red, software de videoconferencia, plataforma de educación en línea,plataforma interactiva de educación en línea,plataforma de transmisión en vivo de vídeo en red, planificación de eventos en vivo, planificación de eventos en vivo, navegación interactiva de pantallas múltiples',
    website_1003:
      'Vhall, un proveedor de servicios profesionales de la plataforma de actividades comerciales en línea del mundo, la plataforma de transmisión por internet más grande; proporciona servicios de transmisión por Internet,  educación en línea y videoconferencia, etc, admite navegación interactiva en múltiples pantallas; línea directa de teléfono de alquiler: 400-888-9970.',
    website_1004: 'Presione ESC para salir del modo de pantalla completa'
  },
  common: {
    common_1001: 'Cargando...',
    common_1002: 'Contenedor compartido de escritorio',
    common_1003: 'Invitación',
    common_1004: 'Pregunta y respuesta',
    common_1005: 'Pagar con éxito',
    common_1006:
      'Por favor, ingrese el número de teléfono móvil / correo electrónico / número de trabajo',
    common_1007:
      'El tipo de detección y el tipo de restricción de visualización de la actividad son inconsistentes',
    common_1008: 'Charla privada',
    common_1009: 'Chino simplificado',
    common_1010: 'Confirmar',
    common_1011: 'Arrastra el control deslizante hacia la derecha para rellenar el rompecabezas',
    common_1012: 'Hora de inicio',
    common_1013: 'Número de personas en línea',
    common_1014: 'Diez mil',
    common_1015: 'Cien millones',
    common_1016: 'Billones',
    common_1017: 'Breve introducción a la actividad',
    common_1018: 'Transmisión en vivo',
    common_1019: 'Vista previa',
    common_1020: 'Finalizar',
    common_1021: 'Reproducir',
    common_1022: 'Transmisión en vivo cronometrada',
    common_1023: 'Sin demora',
    common_1024: 'Bajo demanda',
    common_1025: 'Subtítulo',
    common_1026: 'Transmisión de audio en vivo',
    common_1027: 'Video en vivo',
    common_1028: 'Transmisión de audio en vivo',
    common_1029: 'Transmisión de audio en vivo',
    common_1030: 'Haga clic',
    common_1031: 'Número de reservas',
    common_1032: 'Número de espectadores',
    common_1033: '我知道了',
    common_1034: '',
    common_1035: '',
    common_1036: '',
    common_1037: 'Introduction'
  },
  player: {
    player_1001: 'Grado de calor',
    player_1002: 'Pintura original',
    player_1003: 'Definición alta',
    player_1004: 'Definición estándar',
    player_1005: 'Súper definición',
    player_1006: 'Audio',
    player_1007: 'Doble velocidad',
    player_1008: 'Cambiar',
    player_1009: 'Ha cambiado a...para usted',
    player_1010: 'El contenido se presentará pronto ...',
    player_1011: 'Has entrado en el modo de pantalla horizontal',
    player_1012: 'Ha visto por última vez a {n}, se renueva automáticamente para usted',
    player_1013: 'Ver en seguida',
    player_1014: 'Reproduciendo la voz...',
    player_1015: 'Ha cambiado a la velocidad normal para usted',
    player_1016: 'Reproducir',
    player_1017: 'La transmisión en vivo ha terminado',
    player_1018: 'La transmisión en vivo ha comenzado, por favor, vea la transmisión en vivo',
    player_1019: 'Falló la configuración de doble velocidad',
    player_1020: 'Falló la configuración de claridad',
    player_1021: 'Pausa',
    player_1022: 'Reproducir',
    player_1023: 'Ajustar el tiempo de reproducción falló',
    player_1024: 'El tiempo de configuración falló, inténtelo de nuevo más tarde',
    player_1025: '',
    player_1026: 'replaying',
    player_1027: 'There is no rehearsal now, please come again next time'
  },
  appointment: {
    appointment_1001: 'Verificación de lista blanca',
    appointment_1002:
      'Ingrese el número de teléfono móvil / correo electrónico / número de trabajo',
    appointment_1003: 'La actividad no existe',
    appointment_1004: 'Ha reservado con éxito',
    appointment_1005:
      'Por favor, visite esta página el día de la transmisión en vivo para ver la transmisión en vivo',
    appointment_1006: 'Ha reservado con éxito',
    appointment_1007: 'Su información no está en la lista blanca',
    appointment_1008: 'Sin lista blanca',
    appointment_1009: 'Ingrese la contraseña',
    appointment_1010: 'Pagar',
    appointment_1011: 'Código de invitación',
    appointment_1012: 'Puede ver {n} minutos gratis, para el video completo, por favor ...',
    appointment_1013: 'La prueba de video ha terminado, ve el video completo',
    appointment_1014: 'Probar el video de nuevo',
    appointment_1015: 'Antes de la transmisión en vivo',
    appointment_1016: 'Ha iniciado la transmisión en vivo',
    appointment_1017: 'Reservar en seguida',
    appointment_1018: 'han sido reservadas {n} personas',
    appointment_1019: 'Está vacío aquí',
    appointment_1020: 'Watch verification',
    appointment_1021: 'Error de contraseña',
    appointment_1022: 'Por favor, ingrese la contraseña',
    appointment_1023: 'Paga {n} para ver',
    appointment_1024: 'Por favor, ingrese el código de invitación',
    appointment_1025: 'Ver verificación',
    appointment_1026: 'Día',
    appointment_1027: 'Hora',
    appointment_1028: 'Minuto',
    appointment_1029: 'Segundo',
    appointment_1030: 'El patrocinador de la actividad configuró una prueba de video',
    appointment_1031: 'Por favor sea paciente',
    appointment_1032: 'Lista blanca',
    appointment_1033: 'The rehearsal has started, please watch it live',
    appointment_1034: '',
    appointment_1035: ''
  },
  nav: {
    nav_1001: 'Patrocinador',
    nav_1002: 'Cuenta oficial',
    nav_1003: 'Ha seguido',
    nav_1004: 'Seguir',
    nav_1005: 'Iniciar sesión',
    nav_1006: 'Mi transmisión en vivo',
    nav_1007: 'Centro financiero',
    nav_1008: 'Mi página de inicio',
    nav_1009: 'Configuración de la cuenta',
    nav_1010: 'Cerrar',
    nav_1011: 'Cerrar sesión',
    nav_1012: 'Seguir la cuenta oficial',
    nav_1013: 'Compartir',
    nav_1014: 'Copiar',
    nav_1015: 'Tarjeta de invitación',
    nav_1016: 'WeChat',
    nav_1017: 'Weibo',
    nav_1018: 'QQ',
    nav_1019: 'Utiliza el "escaneo" de WeChat',
    nav_1020: 'Utiliza el "escaneo" de WeChat para seguir la cuenta oficial',
    nav_1021: 'Mantenga pulsado para identificar el código QR en la imagen',
    nav_1022: 'Puede compartir la actividad con amigos o momentos de WeChat',
    nav_1023: 'Obtiene y reenvía su propia tarjeta de invitación exclusiva',
    nav_1024: 'Copiar con éxito',
    nav_1025: 'Hace clic para ver más detalles',
    nav_1026: 'Vhall en vivo',
    nav_1027: 'Hace clic para ver los detalles',
    nav_1028: 'Gestión de retiros',
    nav_1029: 'Deja de seguir',
    nav_1030: 'Seguir con éxito',
    nav_1031: 'Presione y guarde en local',
    nav_1032: 'Lista de invitaciones',
    nav_1033: 'Lista de recompensas',
    nav_1034: 'Reglas de clasificación',
    nav_1035: 'Reglas de la lista de recompensas',
    nav_1036: 'No hay reglas.',
    nav_1037: 'Invitar a {n} personas',
    nav_1038: 'No hay ofertas en este momento. Consigue el sofá ahora ~',
    nav_1039: 'Actualmente no hay recompensa. ¡Consigue el sofá! ~',
    nav_1040: 'Aún no has invitado, consigue el sofá ~',
    nav_1041: 'Tuhao, por una recompensa',
    nav_1042: 'Invitar a un amigo para ver',
    nav_1043: 'Ha terminado',
    nav_1044: 'Te invita a ver la transmisión en vivo',
    nav_1045: 'Participación inmediata en eventos',
    nav_1046: 'Escanea el código qr',
    nav_1047: 'Presione largo para guardar la imagen para compartir',
    nav_1048: 'Tiempo',
    nav_1049: 'Ubicación',
    nav_1050: 'Anchor aún no ha activado la invitación',
    nav_1051: '',
    nav_1052: '',
    nav_1053: '',
    nav_1054: 'Share the rehearsal viewing address',
    nav_1055: '',
    nav_1056: 'Has been off the shelves',
    nav_1057: '',
    nav_1058: ''
  },
  login: {
    login_1001: 'Inicio de sesión de cuenta',
    login_1002: 'Inicio de sesión con teléfono móvil',
    login_1003: 'Inicio de sesión con código de verificación',
    login_1004: 'Inicio de sesión con contraseña',
    login_1005: 'Inicio de sesión automático',
    login_1006: 'Iniciar sesión en seguida',
    login_1007: 'No ha iniciado sesión',
    login_1008: 'Otros métodos de inicio de sesión',
    login_1009: 'Inicio de sesión con QQ',
    login_1010: 'Por favor, ingrese el número de teléfono móvil / correo electrónico',
    login_1011: 'Por favor, ingrese la contraseña de inicio de sesión',
    login_1012: 'Olvidar la contraseña',
    login_1013: 'Error de contraseña de la cuenta',
    login_1014: 'Por favor, establezca la contraseña de inicio de sesión (6 - 30 caracteres)',
    login_1015:
      'Falló la adquisición de la información de inicio de sesión, por favor, inicie sesión de nuevo',
    login_1016: 'Solicitud inusual, no se puede operar',
    login_1017: 'El código gráfico no está validado para aprobar',
    login_1018: 'Por favor, ingrese el código de verificación de gráfico',
    login_1019: 'Por favor, ingrese su número de teléfono móvil o correo electrónico',
    login_1020: 'Por favor, ingrese la contraseña de su cuenta',
    login_1021: 'Falló el inicio de sesión',
    login_1022: 'Por favor ingrese su cuenta',
    login_1023: 'Error de código gráfico',
    login_1024: 'Las dos contraseñas ingresadas son inconsistentes!',
    login_1025: 'Las dos contraseñas ingresadas son inconsistentes!',
    login_1026: 'Iniciar sesión',
    login_1027: 'He leído y estoy de acuerdo Condiciones de servicio',
    login_1028: 's',
    login_1029: 'La verificación del número de teléfono móvil falló, no se puede operar',
    login_1030: 'Consentimiento y cumplimiento',
    login_1031: 'Condiciones de servicio',
    login_1032: '',
    login_1033: '',
    login_1034: '',
    login_1035: '',
    login_1036: '',
    login_1037: '',
    login_1038: '',
    login_1039: '',
    login_1040: '',
    login_1041: '',
    login_1042: '',
    login_1043: '',
    login_1044: '',
    login_1045: '',
    login_1046: '',
    login_1047: '',
    login_1048: '',
    login_1049: '',
    login_1050: '',
    login_1051: '',
    login_1052: '',
    login_1053: '',
    login_1054: '',
    login_1055: '',
    login_1056: '',
    login_1057: '',
    login_1058: '',
    login_1059: '',
    login_1060: ''
  },
  register: {
    register_1001: 'Bienvenida a registrarse Vhall en vivo',
    register_1002: 'Registrar un nuevo usuario',
    register_1003: 'Por favor, compruebe el protocolo primero',
    register_1004: 'Falló el envío',
    register_1005: 'Regístrese en seguida',
    register_1006: 'El número de teléfono móvil ya está registrado',
    register_1007: 'Establecer contraseña (opcional, 6-30 caracteres)',
    register_1008: 'He leído y estoy de acuerdo',
    register_1009: 'Registrar con éxito',
    register_1010: 'Falló el registro',
    register_1011: 'Condiciones de servicio y acuerdo de privacidad',
    register_1012: 'Por favor, compruebe el protocolo primero',
    register_1013: 'Registro'
  },
  footer: {
    footer_1001: 'Comentarios e informes',
    footer_1002: 'Clasificación de problemas',
    footer_1003: 'Ver los problemas',
    footer_1004: 'Informe de contenido',
    footer_1005: 'Tartamudeo',
    footer_1006: 'Pantalla negra',
    footer_1007: 'Sonido desincronizado',
    footer_1008: 'El asistente se bloqueó',
    footer_1009: 'Problema de inserción de vídeo',
    footer_1010: 'Problema de configuración de cámara',
    footer_1011: 'Problema de audio',
    footer_1012: 'Falló la fuente compartida de software',
    footer_1013:
      'Difunde pornografía, violencia, información reaccionaria y otra información ilegal e indeseable',
    footer_1014: 'Fraude',
    footer_1015: 'Venta piramidal',
    footer_1016: 'Culto',
    footer_1017: 'Descripción',
    footer_1018: 'El contenido no puede ser mayor de 1.000 caracteres',
    footer_1019: 'Retroalimentación del problema exitosa',
    footer_1020: 'Por favor, describa los detalles del problema',
    footer_1021: 'Vhall proporciona soporte técnico'
  },
  chat: {
    chat_1001: 'Participar en el chat después de iniciar sesión',
    chat_1002: 'Hacer preguntas después de iniciar sesió',
    chat_1003: 'Ven y haz preguntas',
    chat_1004: 'Ingresar lo que quiere decir',
    chat_1005: 'El contenido no puede tener más de 140 caracteres',
    chat_1006: 'Ha sido silenciado',
    chat_1007: 'Se han echado de la habitación',
    chat_1008: 'Se le ha prohibido el acceso a la habitación',
    chat_1009: 'El contenido no puede estar vacío',
    chat_1010: 'Enviar con éxito',
    chat_1011: 'Falló el envío',
    chat_1012: 'Ver sólo al patrocinador',
    chat_1013: 'Efectos de blindaje',
    chat_1014: 'Ha activado ver sólo al patrocinador',
    chat_1015: 'Ha cerrado ver sólo al patrocinador',
    chat_1016: 'Ha bloqueado los efectos especiales',
    chat_1017: 'Ha activado los efectos especiales',
    chat_1018: 'Ver sólo el mío',
    chat_1019: 'Ha activado ver sólo el mío',
    chat_1020: 'Ha cerrado ver sólo el mío',
    chat_1021: 'Participar en el chat',
    chat_1022: 'Anfitrión',
    chat_1023: 'Invitados',
    chat_1024: 'Asistente',
    chat_1025: 'Enviar con demasiada frecuencia ~',
    chat_1026: 'Preguntas y respuestas abiertas',
    chat_1027: 'Firma iniciada',
    chat_1028: 'Firma terminada',
    chat_1029: 'Sobres rojos premiados',
    chat_1030: 'Cuestionario enviado',
    chat_1031: 'Ver detalles',
    chat_1032: 'Enviar',
    chat_1033: 'Sobres rojos enviados',
    chat_1034: 'Alguien te',
    chat_1035: 'Hay {n} mensajes no leídos',
    chat_1036: 'Respuesta',
    chat_1037: '¡Es maravilloso, me gusta!',
    chat_1038: 'Se están distribuyendo sobres rojos',
    chat_1039: 'Esta pregunta ha sido respondida en la transmisión en vivo',
    chat_1040: 'Pregunta',
    chat_1041: 'Respuesta',
    chat_1042: 'Di algo',
    chat_1043: 'Participación en interacciones',
    chat_1044: 'Ha sido silenciado',
    chat_1045: 'Di algo',
    chat_1056: 'Falló el envío',
    chat_1057: 'El contenido no puede estar vacío',
    chat_1058: 'Ver mensajes históricos',
    chat_1059: 'llama',
    chat_1060: 'Ver el cuestionario',
    chat_1061: 'Enviar',
    chat_1062: 'No definido',
    chat_1063: 'Los espectadores',
    chat_1064: '组长',
    chat_1065: 'La imagen falla al cargar',
    chat_1066: 'Por favor ingrese una pregunt',
    chat_1067: 'faltan {n} segundos para hablar',
    chat_1068:
      'El sitio de la actividad está demasiado animado，por favor hable de nuevo en {n} segundos',
    chat_1069: 'Máximo 140 palabras',
    chat_1070: '观众{n}结束了演示',
    chat_1071: '主持人已将您分配至{n}组',
    chat_1072: '主持人开启了分组讨论，您将进入{n}组参与讨论',
    chat_1073: '主持人结束了分组讨论，您将返回主直播间',
    chat_1074: '主持人解散了分组，您将返回主直播间',
    chat_1075: '',
    chat_1076: '',
    chat_1077: 'En silencio te contesta',
    chat_1078: 'Hay un nuevo mensaje',
    chat_1079: '',
    chat_1080: '',
    chat_1081: '',
    chat_1082: '',
    chat_1083: '',
    chat_1084: '',
    chat_1085: '',
    chat_1086: '',
    chat_1087: '',
    chat_1088: '',
    chat_1089: '',
    chat_1090: '',
    chat_1091: '',
    chat_1092: '',
    chat_1093: '',
    chat_1094: '',
    chat_1095: '',
    chat_1096: '',
    chat_1097: '',
    chat_1098: 'Hace clic para ver los detalles',
    chat_1099: ''
  },
  form: {
    form_1001: 'Nombre',
    form_1002: 'Zona',
    form_1003: 'Correo electrónico',
    form_1004: 'Por favor, seleccione provincia',
    form_1005: 'Por favor, seleccione ciudad',
    form_1006: 'Por favor, seleccione distrito / condado',
    form_1007: 'Por favor, ingrese el correo electrónico',
    form_1008: 'Por favor, ingrese el formato de correo electrónico correcto',
    form_1009: 'La longitud de correo electrónico no puede ser superior a 80',
    form_1010: 'Por favor, ingrese un correo electrónico correcto',
    form_1011: 'Desplegar',
    form_1012: 'Guardar',
    form_1013: 'Declaración de privacidad',
    form_1014: 'Por favor, ingrese',
    form_1015: 'Masculino',
    form_1016: 'Femenino',
    form_1017: 'Por favor, ingrese el contenido de descripción',
    form_1018: 'Por favor, seleccione',
    form_1019: 'Registrarse',
    form_1020: 'Por favor, ingrese el código de verificación',
    form_1021: 'Enviar el código de verificación',
    form_1022: 'Por favor, ingrese el número de teléfono móvil que ingresó durante el registro',
    form_1023: 'Por favor, ingrese el correo electrónico',
    form_1024: 'Me he registrado',
    form_1025: 'Registrarse de la actividad',
    form_1026: 'Por favor, ingrese el nombre',
    form_1027: 'Por favor, seleccione el género',
    form_1028: 'Por favor, ingrese el contenido',
    form_1029: 'Por favor, seleccione el contenido',
    form_1030: 'Por favor, seleccione primero el acuerdo de privacidad',
    form_1031: 'Falló la información básica del formulario de registro',
    form_1032:
      'La información se envía con éxito, la transmisión en vivo comenzará oficialmente en {n}, por favor, participe a tiempo',
    form_1033: 'Se ha registrado, y se ha verificado con éxito',
    form_1034: 'Por favor, regístrese primero',
    form_1035: 'Sí',
    form_1036: 'No',
    form_1037: 'El cuestionario ha sido enviado con éxito, gracias por su participación',
    form_1038: 'Por favor, establezca las opciones',
    form_1039: 'La opción no puede estar vacía',
    form_1040: 'El título del cuestionario no puede estar vacío',
    form_1041: 'Por favor, ingrese las opciones',
    form_1042: 'Por favor, ingrese la dirección detallada',
    form_1043:
      'Provincia / región autónoma / municipio directamente dependiente del Gobierno central',
    form_1044: 'Distrito / condado',
    form_1045: 'Presentar',
    form_1046: 'Seleccionar la fecha',
    form_1047: 'Seleccionar la fecha + la hora',
    form_1048: 'Seleccionar la hora',
    form_1049: 'Añadir opciones de columna',
    form_1050: 'Elementos obligatorios',
    form_1051: 'Añadir opciones de fila',
    form_1052: 'Añadir opciones',
    form_1053: 'Por favor, ingrese el título',
    form_1054: 'Empresa',
    form_1055: 'Género',
    form_1056: 'Cargo',
    form_1057: 'Director ejecutivo / Gerente general',
    form_1058: 'Director de información / Gerente de TI',
    form_1059: 'Director de marketing / Gerente',
    form_1060: 'Director de ventas / Gerente',
    form_1061: 'Director Técnico / Gerente',
    form_1062: 'Técnicos de Ingeniería',
    form_1063: 'Otros',
    form_1064: 'Teléfono móvil',
    form_1065: 'Cumpleaños',
    form_1066: 'Industria',
    form_1067: 'Nivel de educación',
    form_1068: 'Preguntas de opción única',
    form_1069: 'Preguntas de opción múltiple',
    form_1070: 'Preguntas y respuestas',
    form_1071: 'Pregunta desplegable',
    form_1072: 'Subsección',
    form_1073: 'Título',
    form_1074: 'Cuestionario',
    form_1075:
      'Protegemos toda la información que ingresó de acuerdo con la "Declaración de privacidad"',
    form_1076: 'Código de verificación',
    form_1077: 'Opciones',
    form_1078: 'Formulario de registro',
    form_1079: 'Contraseña',
    form_1080: 'El contenido no puede ser mayor de 60 caracteres',
    form_1081: 'El contenido no puede ser mayor de 60 caracteres',
    form_1082: 'Verificación',
    form_1083: '',
    form_1084: '',
    form_1085: '',
    form_1086: '',
    form_1087: 'Enviar con éxito, gracias por su participación',
    form_1088: 'Enviar con éxito',
    form_1089: '',
    form_1090: '',
    form_1091: 'My Gift'
  },
  menu: {
    menu_1001: 'Documentación',
    menu_1002: 'Charlar',
    menu_1003: 'Breve introducción',
    menu_1004: 'Producto',
    menu_1005: 'Recomendar',
    menu_1006: 'Precio preferencial',
    menu_1007: 'Comprar',
    menu_1008: 'Detalles del producto',
    menu_1009: 'Visitar la tienda',
    menu_1010: 'Chequear',
    menu_1011: 'Sin imagen',
    menu_1012: 'Gráfico por defecto',
    menu_1013: 'Capítulos',
    menu_1014: '',
    menu_1015: ''
  },
  interact_tools: {
    interact_tools_1001: 'Por favor, ingrese el título del sorteo',
    interact_tools_1002: 'El sorteo está en curso',
    interact_tools_1003: 'Sorteo',
    interact_tools_1004: 'Por favor, ingrese la dirección',
    interact_tools_1005: 'Por favor, ingrese el nombre',
    interact_tools_1006: 'Recibir el premio',
    interact_tools_1007: 'Enviar {n} para participar en el sorteo',
    interact_tools_1008: 'Participar en seguida',
    interact_tools_1009: 'Premio',
    interact_tools_1010: 'Perdó el premio',
    interact_tools_1011: 'Gracias por su participación',
    interact_tools_1012: 'Ver la lista de ganadores',
    interact_tools_1013: '¡La información se envió con éxito!',
    interact_tools_1014: '¡El envío de la información falló!',
    interact_tools_1015: '¡Ganó el premio!',
    interact_tools_1016: 'Felicitaciones por conseguir',
    interact_tools_1017: 'Recibir el premio en seguida',
    interact_tools_1018:
      'Por favor, rellene la información de recibir el premio, para que el organizador pueda ponerse en contacto con usted',
    interact_tools_1019: 'Presentar',
    interact_tools_1020: 'Lista de ganadores',
    interact_tools_1021: 'El sorteo está en curso',
    interact_tools_1022: 'Desafortunadamente, ¡no ganó ningún premio!',
    interact_tools_1023: '¡Felicitaciones por ganar! Haga clic para ver más detalles',
    interact_tools_1024: 'Registrarse',
    interact_tools_1025: 'El anfitrión inicia el registro...',
    interact_tools_1026: 'Regístrese en seguida',
    interact_tools_1027: 'Registrarse con éxito',
    interact_tools_1028: 'Falló el registro',
    interact_tools_1029: 'Regalo',
    interact_tools_1030: 'Regalar',
    interact_tools_1031: 'Regalar con éxito',
    interact_tools_1032: 'Gracias por su apoyo',
    interact_tools_1033: 'Ha depositado en la cuenta personal',
    interact_tools_1034: 'La velocidad es lenta',
    interact_tools_1035: 'No hay sobres rojos',
    interact_tools_1036: 'Mirar la suerte de todos',
    interact_tools_1037: 'Cómo se retira el efectivo',
    interact_tools_1038:
      'Los usuarios registrados en Wechat pueden seguir la cuenta oficial de Vhall y retirar efectivo en los ingresos del sobre rojo',
    interact_tools_1039:
      'El sobre rojo que obtienen los usuarios registrados por otros métodos puede realizar la operación de retiro en la [Gestión de retiros] de su cuenta personal después de iniciar sesión en la PC',
    interact_tools_1040: 'Deletrear',
    interact_tools_1041: 'General',
    interact_tools_1042: 'Óptimo',
    interact_tools_1043: 'Recibir {n}',
    interact_tools_1044: 'Recompensar',
    interact_tools_1045: 'Por favor, seleccione la cantidad de la recompensa',
    interact_tools_1046: 'Recompensar otros montos',
    interact_tools_1047: 'Muy emocionante, hace clic en el botón "me gusta"',
    interact_tools_1048: 'Forma de pago',
    interact_tools_1049: 'Pagar con Wechat',
    interact_tools_1050: 'Pagar',
    interact_tools_1051: '【Escanear】 para pagar',
    interact_tools_1052: 'Abrir',
    interact_tools_1053: 'El tiempo ha expirado, comienza a contar hacia adelante',
    interact_tools_1054: 'Cuenta regresiva',
    interact_tools_1055: 'Ha pausado',
    interact_tools_1056: 'Ha terminado',
    interact_tools_1057: 'En curso...',
    interact_tools_1058: 'Gratis',
    interact_tools_1059: 'Café',
    interact_tools_1060: 'Hacer clic en el botón "me gusta"',
    interact_tools_1061: 'Aplaudir',
    interact_tools_1062: 'Flores frescas',
    interact_tools_1063: 'Regalar con éxito',
    interact_tools_1064: 'Por favor, seleccione regalo',
    interact_tools_1065: 'Envía tu clave {n} y participa en el sorteo',
    interact_tools_1066: 'Por favor complete',
    interact_tools_1067: 'Llenado con éxito',
    interact_tools_1068: 'El cuestionario ha sido enviado con éxito',
    interact_tools_1069: 'Pago con alipay',
    interact_tools_1070: 'El monto admite hasta dos decimales',
    interact_tools_1071: 'Envía tu clave xxx y participa en el sorteo',
    interact_tools_1072: 'QR en la imagen',
    interact_tools_1073: '',
    interact_tools_1074: '',
    interact_tools_1075: 'Aplaudir',
    interact_tools_1076: '',
    interact_tools_1077: '',
    interact_tools_1078: '',
    interact_tools_1079: '',
    interact_tools_1080: '',
    interact_tools_1081: '',
    interact_tools_1082: '',
    interact_tools_1083: '',
    interact_tools_1085: '',
    interact_tools_1086: '',
    interact_tools_1087: '',
    interact_tools_1088: '',
    interact_tools_1089: '',
    interact_tools_1090: '',
    interact_tools_1091: '',
    interact_tools_1092: '',
    interact_tools_1093: '',
    interact_tools_1094: '',
    interact_tools_1095: '',
    interact_tools_1096: '',
    interact_tools_1097: '',
    interact_tools_1098: '',
    interact_tools_1099: ''
  },
  setting: {
    setting_1002: '',
    setting_1003: '',
    setting_1004: '',
    setting_1005: '',
    setting_1006: 'Pantalla de flujo de empuje',
    setting_1007: 'Imagen',
    setting_1008: 'Cambiando el dispositivo, por favor, espere ...',
    setting_1009: 'Mapa de bits de flujo de video predeterminado',
    setting_1010: 'Falló la conmutación de la cámara, por favor, inténtelo de nuevo más tarde',
    setting_1011: '¿No se ve la pantalla de la cámara? Pruebe los siguientes métodos:',
    setting_1012: 'Por favor, permita que el navegador use la autoridad de la cámara',
    setting_1013: 'Por favor, confirme que la cámara no esté ocupada por otros programas',
    setting_1014: 'Por favor, seleccione una cámara externa o reemplace el ordenador',
    setting_1015: 'Borrar',
    setting_1016: 'Tamaño sugerido: 1280 * 720px, menos de 2MB, compatible con jpg, png',
    setting_1017: 'Por favor, seleccione el micrófono',
    setting_1018: '¿No puede ver la barra de volumen fluctuar cuando habla por el micrófono?',
    setting_1019: 'Pruebe los siguientes métodos:',
    setting_1020: 'Por favor, permita que el navegador use la autoridad del micrófono',
    setting_1021: 'Por favor, confirme que el micrófono no esté ocupado por otros programas',
    setting_1022: 'Seleccione un micrófono externo o reemplace la computadora',
    setting_1023: 'Por favor, seleccione el altavoz',
    setting_1024: 'Hacer clic aquí para reproducir el sonido',
    setting_1025:
      '¿No puede escuchar el sonido cuando hace clic en el botón de reproducción? Pruebe los siguientes métodos:',
    setting_1026: 'Por favor, permita que el navegador use la autoridad del sonido',
    setting_1027: 'Por favor, aumente el volumen del altavoz del dispositivo',
    setting_1028: 'Seleccione un altavoz externo o reemplace la computadora',
    setting_1029: 'Ayuda y apoyo',
    setting_1030: '',
    setting_1031: '',
    setting_1032: '',
    setting_1033: ''
  },
  message: {
    message_1001:
      'El patrocinador ha configurado una función de encriptación de video,Se recomienda utilizar la última versión del navegador Chrome para ver',
    message_1002: 'No se admite la indicación de encriptación de video',
    message_1003: 'La cuenta ha visto esta actividad en otros dispositivos',
    message_1004: '¡Este video está fuera de línea!',
    message_1005: '¡Este tema está fuera de línea!',
    message_1006: 'Esta página ha dejado de brindar servicios',
    message_1007: '¡Se le ha prohibido el acceso a la actividad actual!',
    message_1008:
      '¡El sitio de la actividad está demasiado animado y el número de personas ha excedido el límite superior!',
    message_1009:
      'Está participando en la actividad  con la identidad de anfitrión y no puede verla.Se recomienda borrar las cookies del navegador antes de visitar ~',
    message_1010: 'La red se está agotando',
    message_1011:
      'La versión actual del navegador IE es inferior, por favor, actualice a IE10 y superiorversión, se recomienda utilizar el navegador Chrome para ver ~',
    message_1012:
      '¡La página incrustada sólo admite 3 métodos de verificación: predeterminado, contraseña,Valor K de terceros! Por favor, póngase en contacto con el patrocinador de la actividad',
    message_1013: 'Falta la página, el ingeniero está en camino ...',
    message_1014: 'Transcodificación de video',
    message_1015: 'Falló la validación del valor K, a punto de saltar',
    message_1016:
      'Los anfitriones, invitados o asistentes no pueden ingresar al lado de visualización',
    message_1017:
      'La versión actual no soporta la visualización, por favor cambie a otro navegador',
    message_1018:
      'La versión actual no soporta la visualización, por favor cambie a otro navegador',
    message_1019: 'Se recomienda el uso de una computadora para acceder a la visualización',
    message_1020: 'Este video está fuera de línea',
    message_1021: 'Tipos de actividades no soportadas（Flash）',
    message_1022: 'El sistema se está actualizando',
    message_1023:
      'El sistema se está actualizando de 00: 00 a 07: 00, lo que puede causarle inconvenientes, ¡por favor, comprenda!',
    message_1024: 'La cuenta ha visto esta actividad en otros dispositivos',
    message_1025: 'Si tiene cualquier problema, consulte al proveedor del enlace',
    message_1026: '',
    message_1027: '',
    message_1028: '',
    message_1029: '',
    message_1030: '',
    message_1031: '',
    message_1032: '',
    message_1033: '',
    message_1034: '',
    message_1035: ''
  },
  cash: {
    cash_1001: 'Gestionar saldo',
    cash_1002: 'La cantidad que se puede retirar',
    cash_1003: 'Yuan',
    cash_1004: 'Retirando',
    cash_1005: 'Retirar',
    cash_1006: 'El saldo actual es inferior a 1 yuan, no se puede retirar temporalmente',
    cash_1007: 'Instrucciones de retiro',
    cash_1008: '¿Cuál es el límite de retiro de sobres rojos?',
    cash_1009:
      'Se puede retirar cuando el saldo del sobre rojo es por encima de 1 yuan, y el monto máximo de retiro único admitido en línea es de 800 yuanes. A petición de la Administración Estatal de Impuestos, cuando los usuarios individuales retiran más de 800 yuanes en un sólo retiro, incurrirán en impuestos sobre la renta individual, por favor, envíe la siguiente información a: finance@vhall.com',
    cash_1010:
      'Usuarios individuales: número de cuenta Vhall, nombre, número de identificación, nombre de cuenta bancaria, número de cuenta, banco de apertura de cuenta',
    cash_1011:
      'Usuarios de la empresa: número de cuenta Vhall, copia escaneada de la licencia comercial con sello oficial, nombre de la cuenta bancaria, número de cuenta, banco de apertura de la cuenta',
    cash_1012:
      'La información personal / de la empresa y la información bancaria deben corresponder',
    cash_1013: 'El retiro de sobre rojo tiene la tarifa de manejo, ¿cuánto es la tarifa de manejo?',
    cash_1014: 'Sin tarifa de manejo',
    cash_1015: '¿Cuántos días se recibirá después de la solicitud de retiro?',
    cash_1016:
      'A partir del día del retiro, la cuenta lo recibirá en un plazo de 7 a 15 días hábiles, y prevalecerá la hora real de recepción',
    cash_1017: '¿Existen otras precauciones para el retiro?',
    cash_1018:
      'No puede retirar efectivo nuevamente durante el ciclo de retiro, y puede retirar efectivo sólo después de que lo reciba la cuenta',
    cash_1019: 'Arrebar sobres rojos',
    cash_1020: 'No hay registro de cambio de la cuenta temporalmente',
    cash_1021:
      'La cuenta corriente no tiene un número de teléfono móvil vinculado, para la seguridad de sus fondos, primero complete la configuración del número de teléfono móvil',
    cash_1022: 'Configurar y continuar retirando',
    cash_1023: 'Por favor, utilice WeChat para escanear el código y vincular su cuenta por cobrar',
    cash_1024: 'Una vez que la vinculación sea exitosa, el retiro continuará automáticamente',
    cash_1025: 'Por favor, ingrese el monto del retiro',
    cash_1026: 'A la cuenta de WeChat',
    cash_1027: 'Retirar en seguida',
    cash_1028: 'Presentar significa que estoy de acuerdo',
    cash_1029: '"Acuerdo de canje de usuarios"',
    cash_1030: 'Por favor, ingrese el valor numérico',
    cash_1031: 'El monto del retiro es de al menos 1 yuan',
    cash_1032: 'El valor de retiro debe ser menor que el monto disponible',
    cash_1033: 'Los resultados de verificación no son satisfactorios, no se puede operar',
    cash_1034: 'El monto admite hasta dos decimales',
    cash_1035: 'Por favor, abra y solicite el retiro en wechat',
    cash_1036: 'Retiro exitoso',
    cash_1037: 'Retirada fallida e inoperable',
    cash_1038: 'Por favor, ingrese el código de verificación',
    cash_1039: 'Error de código de verificación de servicio de mensajes cortos',
    cash_1040: 'No se puede confirmar si el usuario está vinculado a una cuenta de retiro'
  },
  account: {
    account_1001: 'Datos personales',
    account_1002: 'Número de teléfono móvil',
    account_1003: 'El número de teléfono móvil aún no se ha perfeccionado',
    account_1004: 'Reemplazar',
    account_1005: 'Configurar',
    account_1006: 'Apodo',
    account_1007: 'Guardar',
    account_1008: 'Modificar',
    account_1009: 'Avatar',
    account_1010: 'Tamaño sugerido: 140 * 140px',
    account_1011: 'Menos de 2M',
    account_1012: 'Soporta jpg, gif, png, bmp',
    account_1013: 'Contraseña de inicio de sesión',
    account_1014: 'Ha configurado',
    account_1015: 'No ha configurado',
    account_1016: 'Cambiar la contraseña',
    account_1017: 'Configurar la contraseña',
    account_1018: 'Vincular con QQ',
    account_1019: 'Ha vinvulado',
    account_1020: 'No ha vinvulado',
    account_1021: 'Desvincular',
    account_1022: 'Vincular en seguida',
    account_1023: 'Vincular con WeChat',
    account_1024: 'Configurar el número de teléfono móvil',
    account_1025: 'Por favor, ingrese su numero de teléfono móvil',
    account_1026: 'Modificar el número de teléfono móvil vinculado',
    account_1027: 'Perfeccionar el número de teléfono móvil',
    account_1028: 'Error de código gráfico',
    account_1029: 'Código de verificación dinámico',
    account_1030: 'Obtener el código de verificación',
    account_1031: '{n}s',
    account_1032: 'Paso 1: verificar el número de teléfono móvil original',
    account_1033:
      'Para garantizar la seguridad de su cuenta, verifique el número de teléfono móvil vinculado antes de modificar el número de teléfono móvil',
    account_1034: 'Paso 2: configurar un nuevo número de teléfono móvil',
    account_1035: 'Configurar en seguida',
    account_1036: 'Próximo paso',
    account_1037: 'Completar',
    account_1038: 'Configurar una nueva contraseña de inicio de sesión',
    account_1039: 'Ingresar la antigua contraseña de inicio de sesión',
    account_1040: 'Ingresar una nueva contraseña',
    account_1041: 'Ingresar la contraseña de inicio de sesión',
    account_1042: 'Repetir la nueva contraseña',
    account_1043: 'Repetir la contraseña de inicio de sesión',
    account_1044: 'La imagen de portada cargada sólo puede estar en formato png',
    account_1045: 'El tamaño de la imagen de portada cargada  no puede superar los 2MB',
    account_1046: 'La carga de la portada falló',
    account_1047: 'El avatar se modificó con éxito',
    account_1048: 'Falló la modificación del avatar',
    account_1049: 'Por favor, ingrese su número de teléfono móvil',
    account_1050: 'El formato del número de teléfono móvil es incorrecto',
    account_1051: 'Falló el envío de código de verificación',
    account_1052: 'La verificación del número de teléfono móvil falló, no se puede operar',
    account_1053: 'Vincular con éxito',
    account_1054: 'Falló la vinculación',
    account_1055: 'El apodo no puede estar vacío',
    account_1056: 'La longitud del apodo es de 1 - 30 caracteres',
    account_1057: 'El apodo se modificó con éxito',
    account_1058: 'Falló la modificación del apodo',
    account_1059: 'Operar con éxito',
    account_1060:
      'Después de desvincular QQ, no podrá iniciar sesión con QQ. ¿Está seguro de que desea desvincular?',
    account_1061: 'Indicio',
    account_1062: 'Confirmar',
    account_1063: 'Cancelar',
    account_1064: 'Desvincular con éxito',
    account_1065: 'Falló la desvinculación',
    account_1066:
      'Después de desvincular WeChat, no podrá iniciar sesión con WeChat. ¿Está seguro de que desea desvincular?',
    account_1067: 'Portada',
    account_1068: 'Borrar',
    account_1069: 'Por favor, ingrese el número de teléfono móvil válido',
    account_1070: 'Por favor, ingrese el código de verificación dinámica',
    account_1071: '¡Por favor, ingrese la contraseña!',
    account_1072: '¡Contraseña de 6 - 30 bits sin espacios y símbolos especiales!',
    account_1073: '¡Ingrese la contraseña de nuevo!',
    account_1074: 'Las dos contraseñas ingresadas son inconsistentes!',
    account_1075: 'Modificar mi perfil',
    account_1076: 'Borrar',
    account_1077: '',
    account_1078: '',
    account_1079: ''
  },
  interact: {
    interact_1001: 'Levantar la mano para encender el micrófono',
    interact_1002: 'El anfitrión desactivó la función de levantar la mano',
    interact_1003: 'Puede levantar la mano para solicitar el micrófono',
    interact_1004: 'Esperar',
    interact_1005: 'Apagar el micrófono',
    interact_1006: 'Apagar la cámara',
    interact_1007: 'Apagar el micrófono',
    interact_1008: 'El anfitrión le invita a encender el micrófono',
    interact_1009: 'Aceptar',
    interact_1010: 'Negar',
    interact_1011:
      'La conexión al micrófono se interrumpió debido a un problema con el dispositivo, por favor, verifique el dispositivo',
    interact_1012: '{n} está configurado como {m}',
    interact_1013:
      'Falló la suscripción de compartir escritorio debido a problemas de red, vuelve a suscribirse',
    interact_1014:
      'Falló la suscripción de usuario [xxx] debido a problemas de red, vuelve a suscribirse',
    interact_1015: 'Encender el micrófono',
    interact_1016: 'Compruebe si el dispositivo está deshabilitado o ocupado',
    interact_1017: 'Por favor, abra upmai primero',
    interact_1018: 'Apagar el micrófono',
    interact_1019:
      'Su navegador o versión actual no permite la interacción. Actualice la última versión o cambie su navegador chrome',
    interact_1020: 'o',
    interact_1021: 'Empujar el flujo falló',
    interact_1022: 'Encender la cámara',
    interact_1023: 'La cámara está apagada, la otra parte no verá tu imagen',
    interact_1024: 'Encender la cámara',
    interact_1025: 'Falta de respuesta prolongada que conduce al fracaso del upper MCT',
    interact_1026: 'El micrófono está apagado, la otra persona no podrá oírte',
    interact_1027: '',
    interact_1028: '',
    interact_1029: '',
    interact_1030: '',
    interact_1031: '',
    interact_1032: '',
    interact_1033: '主画面',
    interact_1034: 'presentador principal',
    interact_1035: '',
    interact_1036: '',
    interact_1037: '',
    interact_1038: '',
    interact_1039: '',
    interact_1040: '',
    interact_1041: '',
    interact_1042: '',
    interact_1043: ''
  },
  doc: {
    doc_1001: 'Este documento en carga',
    doc_1002: 'Presentador sin documentos añadidos',
    doc_1003: 'El presentador prepara la documentación',
    doc_1004: 'Este documentación está fuera de línea',
    doc_1005: 'Amplificación',
    doc_1006: 'Reducir',
    doc_1007: 'móvil',
    doc_1008: 'restauración',
    doc_1009: 'Para salir del modo de pantalla completa',
    doc_1010: 'Salir del modo de pantalla completa',
    doc_1011: '',
    doc_1012: '',
    doc_1013: '',
    doc_1014: '',
    doc_1015: '',
    doc_1016: '',
    doc_1017: '',
    doc_1018: '',
    doc_1019: '',
    doc_1020: '',
    doc_1021: '',
    doc_1022: '',
    doc_1023: '',
    doc_1024: '',
    doc_1025: '',
    doc_1026: '',
    doc_1027: '',
    doc_1028: '',
    doc_1029: ''
  },
  webinar: {
    webinar_1001: 'Apagar',
    webinar_1002: 'No hay sobres rojos',
    webinar_1003: 'Se ha depositado en su cuenta vhall',
    webinar_1004:
      'Wechat iniciar sesión para robar los usuarios de sobres rojos, puede seguir "wechat live rugido" cuenta pública, retirar dinero en las ganancias de sobres rojos',
    webinar_1005:
      '2.Para los usuarios que han iniciado sesión de otra manera, por favor vaya a e.vhall.com con su computadora para retirar dinero en revenue management',
    webinar_1006: 'Datos aún no disponibles',
    webinar_1007: 'Pausa cronológica',
    webinar_1008: 'Fin del tiempo',
    webinar_1009: 'Cronometraje en progreso',
    webinar_1010: 'Enviar',
    webinar_1011: 'Por favor, introduzca lo que quiere decir',
    webinar_1012: 'Repetir iniciar sesión',
    webinar_1013: 'Copiar palabras clave',
    webinar_1014:
      'Mantenga pulsado para copiar y eliminar el contenido de la clave, compre con la aplicación taobao o abra con el navegador para ver',
    webinar_1015: 'Acceso al evento',
    webinar_1016: 'Acceso solo a través del lado P de la computadora',
    webinar_1017: 'La transmisión en vivo en progreso',
    webinar_1018: 'La transmisión en vivo en progreso',
    webinar_1019: 'Recordatorio de inicio',
    webinar_1020: 'Acceso al evento',
    webinar_1021: 'Ver en vod',
    webinar_1022: 'Mira el playback',
    webinar_1023: 'Acceso al directo',
    webinar_1024: 'Citas pagadas por',
    webinar_1025:
      'Puede recibir alertas de SMS después de vincular el número de teléfono, ya no se pierda la maravillosa transmisión en vivo',
    webinar_1026: 'La cuenta ha visto esta actividad en otros dispositivos',
    webinar_1027: 'Am.',
    webinar_1028: 'Mañana',
    webinar_1029: 'Por la tarde',
    webinar_1030: 'Por la noche',
    webinar_1031: 'Seguir mirando',
    webinar_1032: 'Haga clic para actualiza',
    webinar_1033: 'Teléfono móvil barrido código para ver',
    webinar_1034: 'Error al cargar código qr',
    webinar_1035: 'Utiliza el "escaneo" de WeChat para seguir la cuenta oficial',
    webinar_1036: 'Actividad con contraseña',
    webinar_1037: 'Visitantes',
    webinar_1038: 'Compartir el éxito',
    webinar_1039: 'Reserva',
    webinar_1040: '',
    webinar_1041: '',
    webinar_1042: ''
  },
  color: {
    color_1001: '',
    color_1002: '',
    color_1003: '',
    color_1004: '',
    color_1005: '',
    color_1006: '',
    color_1007: '',
    color_1008: '',
    color_1009: '',
    color_1010: '',
    color_1011: '',
    color_1012: ''
  },
  other: {
    other_1001: '',
    other_1002: '',
    other_1003: '',
    other_1004: '',
    other_1005: '',
    other_1006: '',
    other_1007: '',
    other_1008: '',
    other_1009: '',
    other_1010: '',
    other_1011: '',
    other_1012: '',
    other_1013: '',
    other_1014: '',
    other_1015: '',
    other_1016: '',
    other_1017: '',
    other_1018: '',
    other_1019: '',
    other_1020: '',
    other_1021: '',
    other_1022: '',
    other_1023: '',
    other_1024: '',
    other_1025: '',
    other_1026: '',
    other_1027: '',
    other_1028: ''
  },
  privacy: {
    privacy_1001: '',
    privacy_1002: '',
    privacy_1003: '',
    privacy_1004: '',
    privacy_1005: '',
    privacy_1006: '',
    privacy_1007: ''
  },
  exam: {
    exam_1001: '',
    exam_1002: '',
    exam_1003: '',
    exam_1004: '',
    exam_1005: '',
    exam_1006: 'UTE',
    exam_1007: '',
    exam_1008: '',
    exam_1009: '',
    exam_1010: '',
    exam_1011: '',
    exam_1012: '',
    exam_1013: '',
    exam_1014: '',
    exam_1015: '',
    exam_1016: '',
    exam_1017: '',
    exam_1018: '',
    exam_1019: '',
    exam_1020: '',
    exam_1021: '',
    exam_1022: '',
    exam_1023: '',
    exam_1024: '',
    exam_1025: '',
    exam_1026: '',
    exam_1027: '',
    exam_1028: '',
    exam_1029: '',
    exam_1030: '',
    exam_1031: '',
    exam_1032: '',
    exam_1033: '',
    exam_1034: '',
    exam_1035: '',
    exam_1036: '',
    exam_1037: '',
    exam_1038: '显示具体数字即可',
    exam_1039: '',
    exam_1040: '',
    exam_1041: '',
    exam_1042: '',
    exam_1043: '',
    exam_1044: '',
    exam_1045: '',
    exam_1046: '',
    exam_1047: '',
    exam_1048: '',
    exam_1049: '',
    exam_1050: ''
  }
};
